import { defineMessages, type MessageDescriptor } from 'react-intl';

import { AppVersionApp, AppVersionPlatform } from 'generated/types';

export const APP_VERSION_APP_ORDER: AppVersionApp[] = [
  AppVersionApp.medly,
  AppVersionApp.scan_app,
  AppVersionApp.dha,
];

export const APP_VERSION_PLATFORM_ORDER: AppVersionPlatform[] = [
  AppVersionPlatform.ios,
  AppVersionPlatform.android,
];

export const APP_VERSION_PLATFORM_ICONS: Record<
  AppVersionPlatform,
  'apple' | 'android'
> = {
  [AppVersionPlatform.ios]: 'apple',
  [AppVersionPlatform.android]: 'android',
};

const appLabelMessages = defineMessages({
  [AppVersionApp.medly]: {
    id: 'admin.configurations.app.medly',
    defaultMessage: 'Medly',
  },
  [AppVersionApp.scan_app]: {
    id: 'admin.configurations.app.scan_app',
    defaultMessage: 'Scan App',
  },
  [AppVersionApp.dha]: {
    id: 'admin.configurations.app.dha',
    defaultMessage: 'DHA',
  },
});

const platformLabelMessages = defineMessages({
  [AppVersionPlatform.ios]: {
    id: 'admin.configurations.platform.ios',
    defaultMessage: 'iOS',
  },
  [AppVersionPlatform.android]: {
    id: 'admin.configurations.platform.android',
    defaultMessage: 'Android',
  },
});

export const APP_VERSION_APP_LABEL_MESSAGES: Record<
  AppVersionApp,
  MessageDescriptor
> = {
  [AppVersionApp.medly]: appLabelMessages[AppVersionApp.medly],
  [AppVersionApp.scan_app]: appLabelMessages[AppVersionApp.scan_app],
  [AppVersionApp.dha]: appLabelMessages[AppVersionApp.dha],
};

export const APP_VERSION_PLATFORM_LABEL_MESSAGES: Record<
  AppVersionPlatform,
  MessageDescriptor
> = {
  [AppVersionPlatform.ios]: platformLabelMessages[AppVersionPlatform.ios],
  [AppVersionPlatform.android]:
    platformLabelMessages[AppVersionPlatform.android],
};
